<template>
    <div class="container">
      <div class="title">Heart Rate Training Zones</div>
      <div
        v-for="(zone, index) in zoneData"
        :key="index"
        class="zone"
        :class="zone.class"
      >
        <div id="detailed-bar" class="zone-container">
          <div class="bar" :style="{backgroundColor: zone.bgColor}">
            <div class="bar-fill" :style="{ width: zone.percentage + '%', backgroundColor: zone.color }"></div>
          </div>
          <div class="row">
            <div class="col label" style="width: 45%;">{{ zone.label }}</div>
            <div class="col value time-percent" style="width: 55%;">
              <span>{{ zone.time }}</span><span class="zone-percentage">{{zone.percentage}}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "HeartRateZones",
    props: {
      zoneData: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
  body {
    background-color: #121212;
    color: white;
    margin: 0;
    padding: 20px;
  }
  
  .container {
    margin: auto;
    background-color: #1e1e1e;
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }
  
  .title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 1rem;
    padding-left: 0.5rem;
  }

  .zone-container {
    width: 100%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  
  .zone {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .label {
    flex: 1;
    font-size: 14px;
  }
  
  .bar {
    flex: 3;
    height: 1.2rem;
    margin-right: 0.7rem;
    background-color: #333;
    /* border-radius: 6px; */
    overflow: hidden;
    position: relative;
  }
  
  .bar-fill {
    height: 100%;
    border-radius: 0.25rem;
  }
  
  .value {
    font-size: 12px;
  }
  .time-percent {
    text-align: right;
    padding-right: 1.5rem;
  }
  .zone-percentage {
    color:#909ea0;
    padding-left:0.5rem;
  }
  </style>
  